export const fetchAccount = (url, callback, errorHandler = () => {}) => {
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data['success']) {
                callback();
                loader.hide();
            } else {
                errorHandler();
                loader.hide();
            }
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};

export const fetchArchiveAccount = (url, callback, errorHandler = () => {}) => {
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 'error') {
                errorHandler(data.message);
            } else {
                callback(data);
            }
            loader.hide();
        })
        .catch(() => {
            loader.hide();
        });
};
export const fetchEditAccount = (url, callback, formData, errorHandler = () => {}) => {
    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.errors) {
                errorHandler(data);
            } else {
                callback(data);
            }
            loader.hide();
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};

export const fetchAddAccount = (url, callback, formData, errorHandler = () => {}) => {
    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data['success']) {
                callback(data);
                loader.hide();
            } else {
                errorHandler(data);
                loader.hide();
            }
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};

export const fetchListSelect = (url, callback, errorHandler = () => {}) => {
    fetch(url, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
            loader.hide();
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};

export const fetchIntegrationList = (callback, errorHandler = () => {}) => {
    fetch(routable.getRoute('getIntegrationListByCompany'), {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data);
            loader.hide();
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};
export const fetchIntegrationAccountListByCompany = (url, callback, errorHandler = () => {}) => {
    fetch(url, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 'error') {
                swal({
                    text: data.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('accuntApi.return.swal.button'),
                        value: true,
                        visible: true,
                        className: 'btn btn-primary',
                    },
                });
                errorHandler();
            } else {
                callback(data);
            }
            loader.hide();
        })
        .catch(() => {
            // TODO resolve catch
            loader.hide();
        });
};
